import React, { Component } from "react";
import DetailsPresentaseMengisi from "../../component/detail-kebijakan/DetailsPresentaseMengisi";
class YangMengisi extends Component {
    render(){
        return(
            <>
                <DetailsPresentaseMengisi/>
            </>
        )
    }
}
export default YangMengisi;